import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

export const EmailBodySkeleton: React.FC = () => (
    <div data-testid="email-body-skeleton" role="status" aria-busy="true" className="flex flex-col gap-s min-h-[15rem] py-xs">
        <SkeletonBar className="h-3 w-1/3" />
        <SkeletonBar className="h-3 w-full" />
        <SkeletonBar className="h-3 w-11/12" />
        <SkeletonBar className="h-3 w-full" />
        <SkeletonBar className="h-3 w-2/3" />
    </div>
);
